export default "__VITE_ASSET__6143a599__"